<template>
	<div class="fab-dropdown">
		<div class="dropdown">
			<button ref="element" type="button" :data-bs-auto-close="autoClose" class="btn btn-primary fab-dropdown__btn" data-bs-toggle="dropdown" data-bs-display="static">

				<span v-if="checked && checked.value" class="fab-dropdown__info" data-label="выбрано">
					{{checked.value}}<span class="mx-1">/</span><small>{{checked.total}}</small>
				</span>

				<svg width="32" height="32" viewBox="0 0 256 256" xmlns="http://www.w3.org/2000/svg">
					<path fill="currentColor" d="M224,76.7,179.3,32a15.9,15.9,0,0,0-22.6,0L36.7,152a15.4,15.4,0,0,0-3.6,5.5l-.2.5a16,16,0,0,0-.9,5.3V208a16,16,0,0,0,16,16H216a8,8,0,0,0,0-16H115.3L224,99.3A16.1,16.1,0,0,0,224,76.7Zm-80-9.4L160.7,84,68,176.7,51.3,160ZM48,208V179.3L76.7,208Zm48-3.3L79.3,188,172,95.3,188.7,112Z"/>
				</svg>
			</button>
			<nav class="dropdown-menu" >
				<slot :hide="hide"/>
			</nav>
			<span class="dropdown-overlay"></span>
		</div>
	</div>
</template>
<script>
import { Dropdown } from 'bootstrap'

export default {
	props: {
		autoClose: {
			type: String,
			default: 'true'
		},
		checked: {
			type: Object,
			default: null
		}
	},
	methods: {
		hide() {
			const instance = Dropdown.getInstance(this.$refs.element);
			instance && instance.hide();
		}
	}
}
</script>